import Icon from "~/components/ui/Icon"

interface Item {
    label: string
    complement?: string
    url?: string
}

interface Props {
    label: string
    pages: Item[]
}

export default function Category({ label, pages }: Props) {
    return (
        <div className='px-3 mb-4'>
            <div className='h-14 flex items-center gap-1'>
                <Icon id='CoraçãoVitrine' className='text-black' size={16} />
                <h2 className='relative font-black text-salmon text-lg'>{label}</h2>
            </div>

            <ul className='mb-4'>
                {pages.map((item) => (
                    <li className='mb-2 text-sm leading-5'>
                        {item.url
                            ? (
                                <a className='hover:text-red-600 hover:font-bold' href={item.url}>
                                    {item.label}
                                </a>
                            )
                            : <span>{item.label}</span>}

                        {item.complement && (
                            <span className='mt-1 text-neutral-500 block'>{item.complement}</span>
                        )}
                    </li>
                ))}
            </ul>
        </div>
    )
}
